import React from "react"
import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import Banner from "../../components/IELTS_Academic/Banner"
import Menu from "../../components/IELTS_Academic/Menu"
import RecomendedCourses from "../../components/IELTS_Academic/RecomendedCourses"
import SpeakingModule from "../../components/IELTS_Academic/SpeakingModule"

const Speaking = () => (
  <Layout>
    <SEO title="IELTS Academic - Speaking" />
    <main>
        <Banner />
        <Menu />
        <SpeakingModule />
        <RecomendedCourses />
    </main>
  </Layout>
)

export default Speaking
